import { render, staticRenderFns } from "./SelectPais.vue?vue&type=template&id=0b05ede7&scoped=true"
import script from "./SelectPais.vue?vue&type=script&lang=js"
export * from "./SelectPais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b05ede7",
  null
  
)

export default component.exports